import { JSendError } from './jSendError';

export const isJSendError = (obj?: unknown): obj is JSendError =>
  typeof obj === 'object' &&
  obj !== null &&
  'status' in obj &&
  obj.status === 'error' &&
  'message' in obj &&
  typeof obj.message === 'string';
